import { getSiteAddress } from "@/shared/endpoints/SiteEndpoint.ts";
import { getSiteDailyTags } from "@/pages/human-resources/time-management/endpoints/tags/ScheduleTagsEndpoints.ts";
import { getSiteScheduleTemplates } from "@/pages/human-resources/time-management/endpoints/schedules/templates/ScheduleTemplatesEndpoints.ts";
import { getIndicatorsGroups } from "@/pages/human-resources/time-management/endpoints/indicators/AvailableIndicatorsEndpoint.ts";
import type { SiteScheduleReferenceDataOut } from "@/pages/human-resources/time-management/endpoints/reference/site/inout/SiteScheduleReferenceDataOut.ts";

export default async function loadSiteScheduleReferenceData(
  domainId: string,
  siteId: string,
): Promise<SiteScheduleReferenceDataOut> {
  const [addressOut, templatesOut, tagsOut, indicatorsOut] = await Promise.all([
    getSiteAddress(domainId, siteId),
    getSiteScheduleTemplates(domainId, siteId),
    getSiteDailyTags(domainId, siteId),
    getIndicatorsGroups(siteId),
  ]);
  return {
    siteId,
    addressOut,
    templatesOut,
    tagsOut,
    indicatorsOut,
  };
}
